<template>
  <div class="offer-item">
    <div class="desktop-offer-item" @click.stop="openTransactions(item.public_id)">
      <div class="agreement" @click.stop="copyAgreementId">
        <span class="agreement-id">{{ item?.Agreement?.document_id }}</span>
        <svg height="16" viewBox="0 0 16 16" width="16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke="#A7A7A7" d="M10.6673 8.59998V11.4C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.4V8.59998C1.33398 6.26665 2.26732 5.33331 4.60065 5.33331H7.40065C9.73398 5.33331 10.6673 6.26665 10.6673 8.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
          <path stroke="#A7A7A7" d="M14.6673 4.59998V7.39998C14.6673 9.73331 13.734 10.6666 11.4007 10.6666H10.6673V8.59998C10.6673 6.26665 9.73398 5.33331 7.40065 5.33331H5.33398V4.59998C5.33398 2.26665 6.26732 1.33331 8.60065 1.33331H11.4007C13.734 1.33331 14.6673 2.26665 14.6673 4.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
        </svg>
      </div>
      <div class="name" :title="userName">{{ userName }}</div>
      <div class="rating">{{ item?.Borrower?.rating }}</div>
      <div class="issued">
        {{ offerIssuedDateTime }}
      </div>
      <div class="amount">
        {{ item.got_money / 100 }}
      </div>
      <div class="term">
        {{ offerTerm }}
      </div>
      <div class="percent">
        {{ offerPercent }}
      </div>
      <div class="income">
        {{ item.initial_debt / 100 }}
      </div>
      <div class="issued-by">
        {{ offerIssueDate }}
      </div>
      <div class="repaid-date" v-if="isArchive">
        {{ offerRepaidDate }}
      </div>
      <div class="peni">{{ item.total_penalty / 100 }}</div>
      <div class="total-amount">
        {{ item.rest_debt / 100 }}
      </div>
      <div class="status">
        <div :class="item.status">
          {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
        </div>
      </div>
      <div class="pay loan-actions" v-if="!isArchive" @click.stop="isLoanMenuOpen = true" v-click-outside="hideLoanMenu">
        <div
          class="early-repayment-sent-icon"
          v-if="isShowEarlyRepaymentNotice"
          :title="earlyRepaymentTooltip"
          @click.stop
        >
          <img src="../../../public/custom/images/attention.png" alt="Early repayment notification sent">
        </div>
        <div
          class="claim-sent-icon"
          v-if="isClaimSent"
          :title="claimSentTooltip"
          @click.stop
        >
          <img src="../../../public/custom/images/claim.svg" alt="Claim sent">
        </div>
        <div
          class="lawsuit-filed-icon"
          v-if="isLawsuitFiled"
          :title="lawsuitFiledTooltip"
          @click.stop
        >
          <img src="../../../public/custom/images/legal.svg" alt="Lawsuit filed">
        </div>
        <img
          class="offer-menu-img"
          src="../../../public/custom/images/offer-menu.svg"
          alt="Offer menu image"
          v-if="isShowLoanMenuBtn"
        />
        <div class="offer-menu" v-if="isLoanMenuOpen && isShowLoanMenuBtn">
          <div
            class="offer-menu-item"
            v-if="isLoanOverdue"
            @click.stop="openExpiredModal()"
          >
            <div class="expired-text">{{ $t('message.profile.lender.expiredLoan.link') }}</div>
          </div>
          <div
            class="offer-menu-item"
            v-if="isLawsuitAvailable"
            @click.stop="openLawsuitModal()"
          >
            <div class="expired-text">Подать исковое заявление</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="mobile-offer-item">
      <div class="mobile-action" v-if="isShowMobileActions">
        <base-button
          v-if="isShowMobileCreateClaimBtn"
          :text="$t('message.profile.lender.expiredModal.claimBtn')"
          class="claim-btn"
          @click="openExpiredModal()"
        />
        <base-button
          v-if="isShowMobileLawsuitBtn"
          text="Подать исковое заявление"
          class="lawsuit-btn"
          @click="openLawsuitModal()"
        />
        <div
          class="claim-sent-badge"
          v-if="isClaimSent"
          :title="claimSentTooltip"
          @click.stop
        >
          {{ claimSentTooltip }}
        </div>
        <div
          class="lawsuit-filed-badge"
          v-if="isLawsuitFiled"
          :title="lawsuitFiledTooltip"
          @click.stop
        >
          {{ lawsuitFiledTooltip }}
        </div>
        <div
          class="early-repayment-sent-badge"
          v-if="isShowEarlyRepaymentNotice"
          :title="earlyRepaymentTooltip"
          @click.stop
        >
          {{ earlyRepaymentTooltip }}
        </div>
      </div>
      <div class="preview-block" @click.stop="openTransactions(item.public_id)">
        <div class="mobile-row mobile-agreement" @click.stop="copyAgreementId">
          <div class="title">№ договора</div>
          <div class="data agreement-data">
            <span>{{ item?.Agreement?.document_id }}</span>
            <svg height="16" viewBox="0 0 16 16" width="16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path stroke="#A7A7A7" d="M10.6673 8.59998V11.4C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.4V8.59998C1.33398 6.26665 2.26732 5.33331 4.60065 5.33331H7.40065C9.73398 5.33331 10.6673 6.26665 10.6673 8.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
              <path stroke="#A7A7A7" d="M14.6673 4.59998V7.39998C14.6673 9.73331 13.734 10.6666 11.4007 10.6666H10.6673V8.59998C10.6673 6.26665 9.73398 5.33331 7.40065 5.33331H5.33398V4.59998C5.33398 2.26665 6.26732 1.33331 8.60065 1.33331H11.4007C13.734 1.33331 14.6673 2.26665 14.6673 4.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
            </svg>
          </div>
        </div>
        <div class="mobile-row">
          <div class="title">Заемщик</div>
          <div class="data">{{ userName }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">Рейтинг заемщика</div>
          <div class="data">{{ item?.Borrower?.rating }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">Дата выдачи</div>
          <div class="data">{{ offerIssuedDateTime }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
          <div class="data">{{ (item.got_money / 100).toFixed(2) }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
          <div class="data">{{ mobileOfferTerm }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
          <div class="data">{{ offerPercent }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">Итого к возврату (ОД + %)</div>
          <div class="data">{{ (item.initial_debt / 100).toFixed(2) }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">Дата возврата</div>
          <div class="data">{{ offerIssueDate }}</div>
        </div>
        <div class="mobile-row" v-if="isArchive">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.repaidDate') }}</div>
          <div class="data">{{ offerRepaidDate }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
          <div class="data">{{ item.total_penalty / 100 }}</div>
        </div>
        <div class="mobile-row">
          <div class="title">Итого к погашению</div>
          <div class="data">{{ (item.rest_debt / 100).toFixed(2) }}</div>
        </div>
        <div class="mobile-row mobile-status">
          <div class="title">Статус займа</div>
          <div class="status-badge" :class="item.status">
            {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import BaseButton from '../../components/base/BaseButton.vue';
import { getAwaitingTooltip, isShowAwaitingIcon } from '../../helpers/earlyRepayment';

export default {
  name: "lenderLoanItem",
  components: {
    BaseButton,
  },
  props: {
    item: Object,
    isArchive: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isLoanMenuOpen: false,
      isFullDesc: false
    }
  },
  methods: {
    descToggle() {
      this.isFullDesc = !this.isFullDesc;
    },
    openTransactions(id) {
      this.$emit('openTransactions', id);
    },
    async copyAgreementId() {
      const agreementId = String(this.item?.Agreement?.document_id);

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(agreementId);
        } else {
          this.copyTextFallback(agreementId);
        }
      } catch (error) {
        this.copyTextFallback(agreementId);
      }

      this.$toast.success('Номер договора скопирован в буфер обмена');
    },
    copyTextFallback(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    },
    openExpiredModal() {
      this.isLoanMenuOpen = false;
      this.$emit('openExpiredModal', this.item.public_id);
    },
    openLawsuitModal() {
      this.isLoanMenuOpen = false;
      this.$emit('openLawsuitModal', this.item.public_id);
    },
    loanMenuToggle() {
      this.isLoanMenuOpen = !this.isLoanMenuOpen;
    },
    hideLoanMenu() {
      this.isLoanMenuOpen = false;
    }
  },
  computed: {
    userName() {
      const lastName =
        this.item?.Borrower?.name_ru?.family_name_ru;
      const name =
        (this.item?.Borrower?.name_ru?.given_name_ru).slice(
          0,
          1
        ) + ".";

      return `${lastName} ${name}`;
    },
    offerIssuedDate() {
      return new Date(this.item?.createdAt).toLocaleDateString();
    },
    offerIssuedDateTime() {
      return new Date(this.item?.createdAt).toLocaleString('ru-RU');
    },
    offerTerm() {
      return this.item?.Offer?.loan_term_days + "д.";
    },
    mobileOfferTerm() {
      return this.item?.Offer?.loan_term_days + " д.";
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    offerIssueDate() {
      return new Date(this.item?.due_date).toLocaleDateString();
    },
    offerRepaidDate() {
      if (!this.item?.repaid_date) {
        return '-';
      }

      return new Date(this.item.repaid_date).toLocaleDateString();
    },
    isLoanOverdue() {
      return this.item?.status === 'overdue';
    },
    isLawsuitAvailable() {
      return this.item?.lawsuit?.can_file === true && !this.isLawsuitFiled;
    },
    isLawsuitFiled() {
      return this.isLoanOverdue && this.item?.lawsuit?.filed === true;
    },
    isShowLoanMenuBtn() {
      return !this.isLawsuitFiled && (this.isLoanOverdue || this.isLawsuitAvailable);
    },
    isClaimSent() {
      return this.isLoanOverdue && this.item?.claim?.exists === true && this.item?.claim?.status === 'sent';
    },
    isShowMobileCreateClaimBtn() {
      return this.isLoanOverdue && !this.isLawsuitFiled;
    },
    isShowMobileLawsuitBtn() {
      return this.isLawsuitAvailable && !this.isLawsuitFiled;
    },
    isShowMobileClaimAction() {
      return this.isLoanOverdue || this.isLawsuitAvailable || this.isLawsuitFiled;
    },
    isShowMobileActions() {
      return this.isShowMobileClaimAction || this.isShowEarlyRepaymentNotice;
    },
    isShowEarlyRepaymentNotice() {
      return isShowAwaitingIcon(this.item);
    },
    earlyRepaymentTooltip() {
      return getAwaitingTooltip(this.item, (key, params) => this.$t(key, params));
    },
    claimSentTooltip() {
      const createdAt = this.item?.claim?.created_at;
      const date = createdAt ? new Date(createdAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Претензия отправлена';
      }

      return `Претензия отправлена ${date.toLocaleDateString('ru-RU')}`;
    },
    lawsuitFiledTooltip() {
      const filedAt = this.item?.lawsuit?.created_at;
      const date = filedAt ? new Date(filedAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Иск подан';
      }

      return `Иск подан ${date.toLocaleDateString('ru-RU')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-item {
  width: 100%;
}

.desktop-offer-item {
  width: 100%;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: .895rem;
  line-height: 135%;
  color: #121212;
  cursor: pointer;

  &:hover {
    background-color: #F6F8FF;
  }
}

.agreement {
  width: 110px;
  margin-right: 2px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1a8d48;
  font-weight: 600;
  cursor: pointer;

  &:hover path {
    stroke: #1a8d48;
  }
}

.agreement-id {
  @include overflow-elipsis;
}

.agreement svg,
.agreement-data svg {
  flex-shrink: 0;
}

.name {
  width: 125px;
  margin-right: 2px;
  @include overflow-elipsis;
}

.rating {
  width: 70px;
  margin-right: 2px;
}

.issued {
  width: 106px;
  margin-right: 2px;
}

.amount {
  width: 65px;
  margin-right: 2px;
}

.term {
  width: 45px;
  margin-right: 2px;
}

.percent {
  width: 87px;
  margin-right: 2px;
}

.income {
  width: 100px;
  margin-right: 2px;
}

.issued-by {
  width: 117px;
  margin-right: 2px;
}

.repaid-date {
  width: 117px;
  margin-right: 2px;
}

.peni {
  width: 62px;
  margin-right: 2px;
}

.total-amount {
  width: 65px;
  margin-right: 2px;
}

.status {
  width: 117px;
  margin-right: 2px;
  font-size: 12px;

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.pay {
  width: 56px;
  position: relative;
}

.loan-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.early-repayment-sent-icon {
  display: flex;
  align-items: center;
  cursor: help;

  img {
    width: 22px;
    height: 22px;
  }
}

.claim-sent-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff1d5;
  border-radius: 50%;
  cursor: default;
}

.claim-sent-icon img {
  width: 15px;
  height: 15px;
}

.lawsuit-filed-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffdbdb;
  border-radius: 50%;
  cursor: help;
}

.lawsuit-filed-icon img {
  width: 15px;
  height: 15px;
}

.offer-menu-img {
  height: 22px;
  width: 22px;
  cursor: pointer;
}

.offer-menu {
  width: 195px;
  padding: 0;
  box-sizing: border-box;
  position: absolute;
  bottom: -25px;
  right: -10px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-size: 16px;
  line-height: 135%;
  color: #333333;
  white-space: nowrap;
  cursor: pointer;
  z-index: 3;
  overflow: hidden;
}

.offer-menu-item {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;

  &:not(:last-child) {
    border-bottom: 1px solid #eceef0;
  }

  &:hover {
    background: #f7f7f7;
  }
}

.expired-link {
  margin-bottom: 15px;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: #41BF7B;
}

.expired-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: rgba(51, 51, 51, 0.9);
  white-space: pre-line;
}

.btn-block {
  width: calc(70px + 49 * (100vw / 1920));
  height: 32px;
}

.payment,
.on_due,
.current_debt,
.payment_pending {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
}

.closed,
.paid,
.repaid {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #21a15c;
  background: #d6f9d3;
  border-radius: 6px;
}

.expired,
.overdue,
.payment_failed {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #c93434;
  background: #ffdbdb;
  border-radius: 6px;
}

.signing {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #214ea1;
  background: #d3e5f9;
  border-radius: 6px;
}

.canceled {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #6b6b6b;
  background: #eceef0;
  border-radius: 6px;
}

.pay-btn ::v-deep {
  background-color: white;
  border: 2px solid #41bf7b;
  border-radius: 6px;
  color: #41bf7b;
  padding: 0;
  font-size: calc(8px + 8 * (100vw / 1920));
  font-weight: 600;

  &:hover {
    background-color: #41bf7b;
    color: white;
  }
}

.mobile-offer-item {
  width: 100%;
  padding: 24px 16px 60px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  position: relative;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
  background: #f8f8f8;
  border: 1px solid #cdcdcd;
  margin-bottom: 20px;
  border-radius: 4.8px;
}

.mobile-action {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  gap: 8px;
}

.claim-sent-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
  cursor: help;
}

.lawsuit-filed-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #c93434;
  background: #ffdbdb;
  border-radius: 6px;
  cursor: help;
}

.early-repayment-sent-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
  cursor: help;
}

.claim-btn ::v-deep {
  background-color: white;
  border: 2px solid #cb7723;
  border-radius: 6px;
  color: #cb7723;
  padding: 0 12px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  height: 32px;
  white-space: nowrap;
}

.lawsuit-btn ::v-deep {
  background-color: white;
  border: 2px solid #c93434;
  border-radius: 6px;
  color: #c93434;
  padding: 0 12px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  height: 32px;
  white-space: nowrap;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  box-sizing: border-box;
  cursor: pointer;
}

.mobile-row {
  min-height: 22px;
  margin-bottom: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.mobile-row:last-child {
  margin-bottom: 0;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 115%;
  color: #878787;
}

.data {
  max-width: 58%;
  font-size: 16px;
  line-height: 115%;
  text-align: right;
  word-break: break-word;
}

.agreement-data {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1a8d48;
  font-weight: 600;
  cursor: pointer;
}

.mobile-agreement:hover path {
  stroke: #1a8d48;
}

.mobile-status .status-badge {
  padding: 5px 11px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 115%;
  border-radius: 6px;
}

.mobile-status .status-badge.payment,
.mobile-status .status-badge.on_due,
.mobile-status .status-badge.current_debt,
.mobile-status .status-badge.payment_pending {
  color: #cb7723;
  background: #fff1d5;
}

.mobile-status .status-badge.closed,
.mobile-status .status-badge.paid,
.mobile-status .status-badge.repaid {
  color: #21a15c;
  background: #d6f9d3;
}

.mobile-status .status-badge.expired,
.mobile-status .status-badge.overdue,
.mobile-status .status-badge.payment_failed {
  color: #c93434;
  background: #ffdbdb;
}

.mobile-status .status-badge.signing {
  color: #214ea1;
  background: #d3e5f9;
}

.mobile-status .status-badge.canceled {
  color: #6b6b6b;
  background: #eceef0;
}

@media screen and (max-width: 850px) {
  .desktop-offer-item {
    display: none;
  }

  .mobile-offer-item {
    display: flex;
  }
}
</style>
